import { render, staticRenderFns } from "./ViewVideo.vue?vue&type=template&id=4094041a&scoped=true&"
import script from "./ViewVideo.vue?vue&type=script&lang=js&"
export * from "./ViewVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094041a",
  null
  
)

export default component.exports